import { render, staticRenderFns } from "./SearchDetail.vue?vue&type=template&id=0485185c&scoped=true&"
import script from "./SearchDetail.vue?vue&type=script&lang=js&"
export * from "./SearchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485185c",
  null
  
)

export default component.exports